"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("../Text"));

var _styledSystem = require("styled-system");

var _get = _interopRequireDefault(require("lodash/get"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _excluded = ["totalImages", "selectedIndex", "variant", "caption"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var mediaCounterStyle = (0, _styledSystem.variant)({
  key: 'mediaCounter'
});
var MediaCounterWrapper = ( /*#__PURE__*/0, _styledBase["default"])(_Text["default"], {
  target: "e197n3a00",
  label: "MediaCounterWrapper"
})("font-size:", (0, _styledSystem.themeGet)('fontSizes.s'), ";color:", function (props) {
  return (0, _get["default"])(mediaCounterStyle(props), 'color');
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lZGlhQ291bnRlckNhcHRpb24vTWVkaWFDb3VudGVyQ2FwdGlvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVd0MiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvTWVkaWFDb3VudGVyQ2FwdGlvbi9NZWRpYUNvdW50ZXJDYXB0aW9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgVGV4dCBmcm9tICdjb21wb25lbnRzL1RleHQnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgdGhlbWVHZXQsIHZhcmlhbnQgfSBmcm9tICdzdHlsZWQtc3lzdGVtJztcbmltcG9ydCBnZXQgZnJvbSAnbG9kYXNoL2dldCc7XG5pbXBvcnQgaXNFbXB0eSBmcm9tICdsb2Rhc2gvaXNFbXB0eSc7XG5cbmNvbnN0IG1lZGlhQ291bnRlclN0eWxlID0gdmFyaWFudCh7IGtleTogJ21lZGlhQ291bnRlcicgfSk7XG5cbmNvbnN0IE1lZGlhQ291bnRlcldyYXBwZXIgPSBzdHlsZWQoVGV4dClgXG4gIGZvbnQtc2l6ZTogJHt0aGVtZUdldCgnZm9udFNpemVzLnMnKX07XG4gIGNvbG9yOiAkeyhwcm9wcykgPT4gZ2V0KG1lZGlhQ291bnRlclN0eWxlKHByb3BzKSwgJ2NvbG9yJyl9O1xuYDtcblxuY29uc3QgTWVkaWFDb3VudGVyQ2FwdGlvbiA9ICh7XG4gIHRvdGFsSW1hZ2VzLFxuICBzZWxlY3RlZEluZGV4LFxuICB2YXJpYW50ID0gJ2xpZ2h0JyxcbiAgY2FwdGlvbixcbiAgLi4ucmVzdFxufSkgPT4gKFxuICA8TWVkaWFDb3VudGVyV3JhcHBlciB2YXJpYW50PXt2YXJpYW50fSB7Li4ucmVzdH0+XG4gICAge3NlbGVjdGVkSW5kZXh9IC8ge3RvdGFsSW1hZ2VzfSB7IWlzRW1wdHkoY2FwdGlvbikgPyBg4oCiICR7Y2FwdGlvbn1gIDogJyd9XG4gIDwvTWVkaWFDb3VudGVyV3JhcHBlcj5cbik7XG5cbk1lZGlhQ291bnRlckNhcHRpb24ucHJvcFR5cGVzID0ge1xuICAuLi52YXJpYW50LnByb3BUeXBlcyxcbiAgdG90YWxJbWFnZXM6IFByb3BUeXBlcy5udW1iZXIuaXNSZXF1aXJlZCxcbiAgc2VsZWN0ZWRJbmRleDogUHJvcFR5cGVzLm51bWJlci5pc1JlcXVpcmVkLFxuICBjYXB0aW9uOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgTWVkaWFDb3VudGVyQ2FwdGlvbjtcbiJdfQ== */"));

var MediaCounterCaption = function MediaCounterCaption(_ref) {
  var totalImages = _ref.totalImages,
      selectedIndex = _ref.selectedIndex,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'light' : _ref$variant,
      caption = _ref.caption,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(MediaCounterWrapper, (0, _extends2["default"])({
    variant: variant
  }, rest), selectedIndex, " / ", totalImages, " ", !(0, _isEmpty["default"])(caption) ? "\u2022 ".concat(caption) : '');
};

MediaCounterCaption.propTypes = _objectSpread(_objectSpread({}, _styledSystem.variant.propTypes), {}, {
  totalImages: _propTypes["default"].number.isRequired,
  selectedIndex: _propTypes["default"].number.isRequired,
  caption: _propTypes["default"].string
});
var _default = MediaCounterCaption;
exports["default"] = _default;